import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="36"
    height="36"
    fill="none"
    viewBox="0 0 36 36">
    <circle cx="18" cy="18" r="18" fill="#86499B"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M24.665 13 15.5 22.167 11.332 18"></path>
  </svg>
);

export default SvgIcon;
